import { ActionType, createAsyncAction } from "typesafe-actions";

export const changeLocale = createAsyncAction(
  "@locale/change/request",
  "@locale/change/success",
  "@locale/change/failure"
)<string, string, Error>();

export type Actions = ActionType<typeof changeLocale>;
